import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const LocalesData = pageLocalesData.mechaUnit;
const mechaLocateData = LocalesData.luminae;
const lang = getLanguageByPath();

/**
 *  特装机甲数据
 */
export const mechaData = {
  mechaName: toWebpImage(`${require('./images/' + lang + '/warrior-name.png')}`),
  mechaImg: toWebpImage(require('./images/structure.png')),
  driverImg: toWebpImage(require('./images/per.png')),
  iconBadge: toWebpImage(require('./images/icon-badge.png')),
  maLogo: toWebpImage(require('./images/ma-logo.png')),
  btnBack: toWebpImage(require('./images/' + lang + '/btn-back.png')),
  driverStoryTitle: require('./images/' + lang + '/driver-story-title.png'),
  cvTab: [toWebpImage(require('./images/checked1.png')), toWebpImage(require('./images/checked2.png')), toWebpImage(require('./images/checked3.png'))],
  audioScreen: require('./images/audio-screen.png'),
  mechaInfoTitle: require('./images/' + lang + '/mecha-info-title.png'),
  manufacturerTitle: require('./images/' + lang + '/manufacturer-title.png'),
  basicInfoTitle: LocalesData.basicInfoTitle,
  driverVoiceTitle: LocalesData.driverVoiceTitle,
  mechaStorySubTitle: LocalesData.mechaStorySubTitle,
  roleExperSubTitle: mechaLocateData.roleExperSubTitle,
  driverName: mechaLocateData.driverName,
  driverType: mechaLocateData.driverType,
  driversSex: mechaLocateData.driversSex,
  driversBirthplace: mechaLocateData.driversBirthplace,
  driversStructure: mechaLocateData.driversStructure,
  driversRoleExperText: mechaLocateData.driversRoleExperText,
  mechaInfoType: mechaLocateData.mechaInfoType,
  mechaInfoNums: mechaLocateData.mechaInfoNums,
  mechaInfoHeadHigh: mechaLocateData.mechaInfoHeadHigh,
  mechaInfoEmptyWeight: mechaLocateData.mechaInfoEmptyWeight,
  mechaInfoTotal: mechaLocateData.mechaInfoTotal,
  mechaInfoStory: mechaLocateData.mechaInfoStory,
  manufacturerGruopCh: mechaLocateData.manufacturerGruopCh,
  cvCH: mechaLocateData.cvCH,
  cvEN: mechaLocateData.cvEN,
  cvJA: mechaLocateData.cvJA,
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_Get_Elite_Shally_1CN.wav',
      title: mechaLocateData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_Entrance_Elite_Shally_2CN.wav',
      title: mechaLocateData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_MVP_Elite_Shally_3CN.wav',
      title: mechaLocateData.voice.title3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_Get_Elite_Shally_1EN.wav',
      title: mechaLocateData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_Entrance_Elite_Shally_2EN.wav',
      title: mechaLocateData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_MVP_Elite_Shally_3EN.wav',
      title: mechaLocateData.voice.title3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_Get_Elite_Shally_1JP.wav',
      title: mechaLocateData.voice.title1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_Entrance_Elite_Shally_a_2JP.wav',
      title: mechaLocateData.voice.title2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/Vox_Pilot_MVP_Elite_Shally_a_3JP.wav',
      title: mechaLocateData.voice.title3,
      isPlay: false
    }
  ]
};
